import * as pipes from '.';
export const allPipes = [
  pipes?.StackFilterPipe,
  pipes?.StateFilterPipe,
  pipes?.StatusPipe,
  pipes?.ReplacePipe,
  pipes?.AttributeValueReplacePipe,
  pipes?.DurationPipe,
  pipes?.DistancePipe,
  pipes?.CamelcasePipe,
  pipes?.TitlecaseWithSpacePipe,
  pipes?.TimeConversionPipe,
];
